import React from "react";
import Header from '../header';
import AnalyzeResumeTable from './analyze-resume';
import './analyze-resume.scss'

const AnalyzeResumes = () => {

    return (
        <div className="App">
            <AnalyzeResumeTable />
        </div>
    )
}

export default AnalyzeResumes;